export const modifyVastUrl = (vastUrl: string | undefined, program: CmsProgram) => {
  if (!vastUrl) return undefined;

  const url = new URL(vastUrl);
  url.searchParams.set('cmsid', '2688500');
  url.searchParams.set('vid', program._id);

  return url
    .toString()
    .replace(/iu=([^&]+)/, (_, original) => `iu=${program.ads?.adunit?.val ?? original}`);
};
